import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { reduxForm, getFormValues, Field, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Button } from "reactstrap";
import TextField from "../../commonfields/TextField";
import SelectField from "../../commonfields/SelectField";
import NormaliseExt from "../../utils/NormaliseExt";
import SpinnerModel from "../../commonfields/SpinnerModel";
import Service from "../../services";
import PastDatePicker from "../../commonfields/PastDatePicker";
import "./prospectingDetailsPage.scss"
import { transformDateWithoutTime } from "../../utils/dateUtil";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../utils/Utils";
import warn from '../layout/Leads/NewLead/FieldErrors'
import normaliseZipcode from "../../utils/normaliseZipCode";
import PhoneCheckButton from "../../commonfields/PhoneCheckButton";
import { emailTypes, phoneTypes, sendPhondNumberFormat } from "../../utils/GeneralUtils";
import EmailCheckButton from "../../commonfields/EmailCheckButton";
import validate from "./conatactValidate";
import ValidateSelectField from "../../commonfields/ValidateSelectField";
import EmailTextField from "../../commonfields/EmailTextField";
import { State, Suggestion, suggestions } from "../layout/Leads/LeadDetails";
import PhoneNumberField from "../../commonfields/PhoneNumberfield";
import { TriggerContext } from "../../Context/TriggerContext";
import { BankUserContext } from "../../bankUserContext";
import circleCheck from "./../../images/circle-check-regular.svg";
import fillcircleCheck from "./../../images/check-circle-fill-color.svg";


const EditContactForm: React.FC = (props: any) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [phoneType, setPhoneType] = useState([]);
  const [emailType, setEmailType] = useState([]);
  const [states, setStates] = useState<State[]>([]);
  const [suggestionsData, setSuggestions] = useState<any>();
  const [suggestionsBox, setSuggestionsBox] = useState<boolean>(false);
  const [selectedEmailButtons, setEmailSelectedButtons] = useState<boolean[]>([
    true,
  ]);
  const [selectedPhoneButtons, setPhoneSelectedButtons] = useState<boolean[]>([
    true,
  ]);
  const [emailFields, setEmailFields] = useState<number>(1);
  const [phoneFields, setPhoneFields] = useState<number>(1);
  const [checkEmail, setEmailCheck] = useState(false);
  const [disableAddress, setDisableAddress] = useState(true);
  const service = new Service()
  const triggerContext = React.useContext(TriggerContext);
  const context = useContext(BankUserContext);
  /// Auto suggestion for street address ///

  const streetAddress = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisableAddress(false)
    props.change('zipCode', "")
    props.change('city', "")
    props.change('state', "")
    if (event.target.value !== "") {
      await service.getAddressSuggestions(event.target.value)
        .then((response: AxiosResponse<suggestions>) => {
          if (response.data.suggestions.length != 0 && event.target.value != '') {
            setSuggestions(response.data);
            setSuggestionsBox(true);
          }
          else {
            setSuggestions([]);
            setSuggestionsBox(false);
          }
        })
        .catch((error: AxiosError) => catchError(error, true))
    }
    else {
      setSuggestions(null);
      setSuggestionsBox(false);
    }
  }

  const selectedValue = (indexValue: any) => {
    const suggestionValue = suggestionsData?.suggestions[indexValue]
    props.change("streetAddress", suggestionValue?.street_line)
    props.change("city", suggestionValue?.city)
    props.change("zipCode", suggestionValue?.zipcode)
    const stateId = states.find((m: any) => m.text == suggestionValue?.state)?.value;
    props.change("state", stateId);
    setSuggestionsBox(false);
    setDisableAddress(true)
  };

  const onStreetAddressBlur = () => {
    setTimeout(() => {
      setSuggestionsBox(false);
      setSuggestions(null);
    }, 500)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault(props, "999");
    triggerContext?.setValue(true);
    const editLeadContact = {
      screen: "ProspectTR",
      sections: "createClientContact",
      clientId: props?.clientId,
      clientProductsId: props?.productId,
      clientProductsContactMappingId: props?.clientProductsContactMappingId,
      data: {
        clientId: props?.clientId,
        orgId: context.bankuserDetails?.organization.orgId,
        firstName: props?.formValues?.firstName || null,
        lastName: props?.formValues?.lastName || null,
        title: props?.formValues?.title || null,
        dob: transformDateWithoutTime(props?.formValues?.dob),
        streetAddress: props?.formValues?.streetAddress || null,
        unitSuite: props?.formValues?.unitSuite || null,
        city: props?.formValues?.city || null,
        state: props?.formValues?.state || null,
        zipCode: props?.formValues?.zipCode || null,
        email: props?.formValues?.email || null,
        emailType: props?.formValues?.emailType || null,
        phoneNumber: sendPhondNumberFormat(props?.formValues?.phoneNumber) || null,
        phoneExt: props?.formValues?.phoneExt || null,
        isPrimary: props.formValues?.isPrimary,
        phoneType: props?.formValues?.phoneType || null,
        businessName: props?.formValues?.businessName || null,
        productId: props?.productId || null,
        clientContactId: props?.leadsdata?.clientContactId || props?.formValues?.clientContactId,
        parentClientId: props?.parentClientId,
      },
    };
    service
      .saveOrUpdateContactCard(editLeadContact)
      .then((response: any) => {
        props?.getLeadData();
        props?.refreshLeads();
        props.closeModal && props.closeModal();

      })
      .catch((error: AxiosError) => {
        catchError(error, true);

      });
  };
  // const handleSubmit=(e:any)=>{
  //   e.preventDefault();
  //   console.log(props.formValues)
  //  props.handleFormSubmit(props.formValues)
  //  props.refreshLeads();
  //  props.closeModal && props.closeModal();
  // }

  const getDropwowndata = () => {
    let payload = {

      screen: "ProspectDetails",
      sections: "BusinessInfoEditDropdownsList",
      isJsonReturnObject: true


    };
    service.getLeadsData(payload).then((res: any) => {
      setStates(res.data[0].states)
      setEmailType(res.data[0]?.emailtypes)
      setPhoneType(res.data[0]?.phonetypes)

    }).catch((error: AxiosError) => {
      catchError(error, true);

    });
  }

  useEffect(() => {
    props?.refreshLeads();
    getDropwowndata()
  }, []);

  const handleEmailFields = () => {
    setEmailFields((prevSets) => prevSets + 1);
    setEmailSelectedButtons((prev) => [...prev, false]);
  };

  const handlePhoneFields = () => {
    setPhoneFields((prevSets) => prevSets + 1);
    setPhoneSelectedButtons((prev) => [...prev, false]);
  };

  const handleEmailButtonClick = (index: number) => {
    setEmailSelectedButtons((prev) =>
      prev.map((value, idx) => (idx === index ? !value : false))
    );
  };

  const handlePhoneButtonClick = (index: number) => {
    setPhoneSelectedButtons((prev) =>
      prev.map((value, idx) => (idx === index ? !value : false))
    );
  };

  const EmailCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const error =
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? false
        : true;
    setEmailCheck(error);
  };

  const renderEmailFields = (index: number) => {
    const fieldName = `email${index}`;
    const isPrimary = selectedEmailButtons[index];
    const formValues = props.formValues;
    // set isPrimary true for selected field
    if (formValues && formValues[fieldName]) {
      const value = isPrimary;
      props.dispatch(change("CreateLeadForm", `${fieldName}.isPrimary`, value));
    }

    //  Reset 'isPrimary false' for other email fields
    selectedEmailButtons.forEach((button, i) => {
      if (i !== index) {
        const resetFieldName = `email${i}.isPrimary`;
        if (formValues && formValues[resetFieldName]) {
          props.dispatch(
            change("CreateLeadForm", resetFieldName, selectedEmailButtons[i])
          );
        }
      }
    });
    if (selectedEmailButtons.length > 1 && formValues === undefined) {
      const modifiedEmailSelectedButtons = selectedEmailButtons.map(
        (value, index) => {
          return index === 0 ? false : value;
        }
      );
      if (
        JSON.stringify(modifiedEmailSelectedButtons) !==
        JSON.stringify(selectedEmailButtons)
      ) {
        setEmailSelectedButtons(modifiedEmailSelectedButtons);
      }
    }

    return (
      <>
        <Col md="6">
          <Field
            name={`${fieldName}.email`}
            component={TextField}
            type="text"
            label="Email"
            helpText="Email"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => EmailCheck(e)}
          />
        </Col>
        <Col md="6">
          <Field
            name={`${fieldName}.emailType`}
            component={SelectField}
            type="text"
            label="Email Type"
            values={emailTypes}
            helpText="emailType"
          // disabled={disableAddress}
          />
        </Col>
        {emailFields > 1 && (
          <Col md="2">
            <Field
              name={`${fieldName}.isPrimary`}
              label="Primary"
              component={EmailCheckButton}
              selectedEmailButton={selectedEmailButtons[index]}
              value={selectedEmailButtons[index]}
              handleEmailButtonClick={() => handleEmailButtonClick(index)}
            />
          </Col>
        )}
      </>
    );
  };

  const renderPhoneFields = (index: number) => {
    const fieldName = `phone${index}`;
    const isPrimary = selectedPhoneButtons[index];
    const formValues = props.formValues;
    // set isPrimary true for selected field
    if (formValues && formValues[fieldName]) {
      const value = isPrimary;
      props.dispatch(change("CreateLeadForm", `${fieldName}.isPrimary`, value));
    }

    //  Reset 'isPrimary false' for other phone fields
    selectedPhoneButtons.forEach((button, i) => {
      if (i !== index) {
        const resetFieldName = `phone${i}.isPrimary`;
        if (formValues && formValues[resetFieldName]) {
          props.dispatch(
            change("CreateLeadForm", resetFieldName, selectedPhoneButtons[i])
          );
        }
      }
    });
    if (selectedPhoneButtons.length > 1 && formValues === undefined) {
      const modifiedPhoneSelectedButtons = selectedPhoneButtons.map(
        (value, index) => {
          return index === 0 ? false : value;
        }
      );
      if (
        JSON.stringify(modifiedPhoneSelectedButtons) !==
        JSON.stringify(selectedPhoneButtons)
      ) {
        setPhoneSelectedButtons(modifiedPhoneSelectedButtons);
      }
    }
    return (
      <>
        <Col md="6" className="phoneFiled">
          <Field
            name={`${fieldName}.phone`}
            component={PhoneNumberField}
            type="text"
            label="Phone"
            helpText="PhoneNumber"
          />
        </Col>
        <Col md="2" className="phExt">
          <Field
            name={`${fieldName}.phExt`}
            component={TextField}
            type="text"
            label="Ext."
            helpText="Ext"
            normalize={NormaliseExt}
          />
        </Col>
        <Col md="4" className="phoneType">
          <Field
            name={`${fieldName}.phoneType`}
            component={SelectField}
            type="text"
            label="Phone Type"
            values={phoneTypes}
            helpText="phoneType"
          // disabled={disableAddress}
          />
        </Col>

        {phoneFields > 1 && (
          <Col md="2">
            <Field
              name={`${fieldName}.isPrimary`}
              label="Primary"
              component={PhoneCheckButton}
              selectedPhoneButton={selectedPhoneButtons[index]}
              value={selectedPhoneButtons[index]}
              handlePhoneButtonClick={() => handlePhoneButtonClick(index)}
            />
          </Col>
        )}

      </>
    );
  }

  const handlePrimaryContactClick = () => {
    props?.change('isPrimary', !props?.formValues?.isPrimary)
  }

  const renderPrimaryContact = (field: any) => {
    const { input, meta } = field;
    const isPrimary = input.value;

    return (
      !props?.data?.editLeadContact?.isPrimary ? (
        <button
          disabled={props?.editPrimarycontact}
          onClick={handlePrimaryContactClick}
          className={
            (isPrimary || props?.data?.primary) ? "primary-contact" : "primary-contact-disable"
          }
        >
          {(isPrimary || props?.data?.primary) ? (
            <img
              src={fillcircleCheck}
              alt="circle-icon"
              className="circleIcon"
            />
          ) : (
            <img
              src={circleCheck}
              alt="circle-icon"
              className="circleIcon"
            />
          )}
          Primary Contact
        </button>
      ) : (
        ""
      ))
  }


  return (
    <>
      {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : (
        ""
      )}
      <form autoComplete="off" className="add-newcontactform" onSubmit={handleSubmit}>
        <Card>
          <CardBody>
            <div>
              <div className="contactInfoRow">
                <Col md="6" className="primaryButtonContainer editContainer">
                  <Field
                    name="isPrimary"
                    component={renderPrimaryContact}
                    onClick={handlePrimaryContactClick}
                  />
                </Col>
                <Row>
                  <Col md="6" style={{ paddingRight: "7px", fontWeight: "bold" }}>
                    <Field
                      name="firstName"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="First Name"
                      helpText="firstName"
                      isRequired

                    />
                  </Col>
                  <Col md="6">
                    <Field
                      name="lastName"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Last Name"
                      helpText="lastName"

                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="6" style={{ paddingRight: "7px" }}>
                    <Field
                      name="title"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Title"
                      helpText="title"

                    />
                  </Col>

                  <Col md="6" style={{ position: "relative" }}>
                    <div><label>DOB</label></div>
                    <Field
                      name="dob"
                      component={PastDatePicker}
                      maxDate={new Date()}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="8">
                    <Field
                      name="streetAddress"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Street Address"
                      helpText="title"
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => streetAddress(event)}
                      onBlur={() => onStreetAddressBlur()}
                      autoComplete="nope"

                    />
                    {suggestionsBox && suggestionsData !== null ?
                      <div className="suggestionsbox">
                        {(suggestionsData?.suggestions?.map((m: Suggestion, index: number) => (
                          <>
                            <p
                              className="suggestionsContent"
                              onClick={() => selectedValue(index)}>
                              {m.street_line},{m.city},{m.state},{m.zipcode}
                            </p>
                          </>
                        ))
                        )}
                      </div>
                      : ""
                    }
                  </Col>

                  <Col md="4" style={{ paddingLeft: "0" }}>
                    <Field
                      name="unitSuite"
                      component={TextField}
                      type="text"
                      label="Unit,Suite,etc."
                      helpText="dob"

                    />
                  </Col>
                </Row>
                <Row className="">
                  <Col md="5">
                    <Field
                      name="city"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="City"
                      helpText="city"
                      disabled={disableAddress}

                    />
                  </Col>
                  <Col md="3">
                    <Field
                      name="state"
                      component={SelectField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="State"
                      values={states}
                      helpText="State"
                      disabled={disableAddress}

                    />
                  </Col>
                  <Col md="4">
                    <Field
                      name="zipCode"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      label="Zip Code"
                      helpText="zipCode"
                      normalize={normaliseZipcode}
                      disabled={disableAddress}


                    />
                  </Col>
                </Row>


                <Row>
                  <Col md="7">
                    <Field
                      name="email"
                      component={EmailTextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Email"
                      helpText="Email"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        EmailCheck(e)
                      }
                    />
                  </Col>
                  <Col md="4">
                    <Field
                      name="emailType"
                      component={ValidateSelectField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Email Type"
                      values={emailType}
                      helpText="emailType"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="6" className="phoneFiled">
                    <Field
                      name="phoneNumber"
                      component={PhoneNumberField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Phone Number"
                      helpText="PhoneNumber"
                    />
                  </Col>
                  <Col md="2" className="phExt" style={{ paddingLeft: "0" }}>
                    <Field
                      name="phoneExt"
                      component={TextField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Ext"
                      helpText="Ext"
                      normalize={NormaliseExt}
                    />
                  </Col>
                  <Col md="3" className="phoneType">
                    <Field
                      name="phoneType"
                      component={ValidateSelectField}
                      isPrimary={props?.formValues?.isPrimary}
                      type="text"
                      label="Phone Type"
                      helpText="phoneType"
                      values={phoneType}
                    // disabled={disableAddress}
                    />
                  </Col>


                </Row>


              </div>
            </div>
          </CardBody>
          <div className="contact-save">
            <Button className="contact-button" disabled={props.invalid} type="submit">Save</Button></div>
        </Card>
      </form>
    </>
  );
};
const mapStateToProps = (state: any, props: any) => ({
  initialValues: {
    ...props.data,
    isPrimary: props.data?.primary
  } || {}, // retrieve name from redux store
  formValues: getFormValues("EditContactForm")(state),
});


export default connect(mapStateToProps)(
  reduxForm<Record<string, unknown>, any>({
    form: "EditContactForm",
    enableReinitialize: true,
    validate,
    warn
  })(EditContactForm)
);

